import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA                    } from '@angular/material/dialog';
import { DialogsReturnCode                                } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                                   } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                                   } from 'src/app/managers/loading/loading.manager';
import { SessionManager                                   } from 'src/app/managers/session/session.manager';
import { User                                             } from 'src/app/beans/login/user/user.bean';
import { OMOperator                                       } from 'src/app/beans/operator/operator.bean';
import { OperatorLevel                                    } from 'src/app/beans/operator/operator.level.bean';
import { Result } from 'src/app/beans/result/result.bean';

@Component
({
  selector: 'operator-dialog',
  templateUrl: './operator.dialog.html',
  styleUrls: ['./operator.dialog.scss'],
})

export class OperatorDialog implements OnInit 
{
  public  _operator     : OMOperator
  public  levels        : OperatorLevel[]
  private organizationId: number

  constructor
  (
    private dialogRef : MatDialogRef<OperatorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
  ) {}

  ngOnInit(): void
  {
    //Set operator
    this._operator = this.data.operator

    //Set operator to null
    if( !this._operator )
    {
      this._operator = {
        id           : null, 
        loginName    : null,
        authLevel    : null,
        authorization: null,
        enabled      : 1,
      }
    }

    //Set operatorLevel
    this.levels = this.data.operatorLevel

    //Set organizationId
    this.organizationId = this.data.organizationId
  }

  //---------------------------------------------------------------------------------------------------

  async create()
  {
    let loginName = this._operator.loginName
    let authLevel = this._operator.authLevel

    let enabled   = this._operator.enabled ? 1 : 0

    let response = await this.changeValue("create", loginName, authLevel, enabled);

    this.acceptOperation(response)
  }

  async update()
  {
    let loginName = this._operator.loginName
    let authLevel = this._operator.authLevel
    let enabled   = this._operator.enabled ? 1 : 0

    let response = await this.changeValue("update", loginName, authLevel, enabled);
    this.acceptOperation(response)
  }

  acceptOperation(response: any)
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.OPERATOR_ACCEPTED
        }
      )
    }
  }

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue( action: string, loginName: string, authLevel: number, enabled: number )
  {
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return

    this._loader.start()

    let data: OMOperator = 
    {
      id           : null,
      loginName    : loginName,
      authLevel    : authLevel,
      authorization: null,
      enabled      : enabled,
    }

    let response = null
    if(action === "create") response = await this._handler.operator().create((user as User).token, this.organizationId, data                   )
    if(action === "update") response = await this._handler.operator().update((user as User).token, this.organizationId, this._operator.id, data)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------
}
